/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Save_Group_Before_UsersInputs */

const en_team_manager_save_group_before_users = /** @type {(inputs: Team_Manager_Save_Group_Before_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please save the group first before adding users.`)
};

const fr_team_manager_save_group_before_users = /** @type {(inputs: Team_Manager_Save_Group_Before_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez d’abord enregistrer le groupe avant d’ajouter des utilisateurs.`)
};

const de_team_manager_save_group_before_users = /** @type {(inputs: Team_Manager_Save_Group_Before_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte speichern Sie zuerst die Gruppe, bevor Sie Benutzer hinzufügen.`)
};

const it_team_manager_save_group_before_users = /** @type {(inputs: Team_Manager_Save_Group_Before_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si prega di salvare prima il gruppo prima di aggiungere utenti.`)
};

const ru_team_manager_save_group_before_users = /** @type {(inputs: Team_Manager_Save_Group_Before_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перед добавлением пользователей сначала сохраните группу.`)
};

const es_team_manager_save_group_before_users = /** @type {(inputs: Team_Manager_Save_Group_Before_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarde el grupo primero antes de agregar usuarios.`)
};

const zh_cn2_team_manager_save_group_before_users = /** @type {(inputs: Team_Manager_Save_Group_Before_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先保存群组，然后再添加用户。`)
};

const ja_team_manager_save_group_before_users = /** @type {(inputs: Team_Manager_Save_Group_Before_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーを追加する前に、まずグループを保存してください。`)
};

const hi_team_manager_save_group_before_users = /** @type {(inputs: Team_Manager_Save_Group_Before_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया उपयोगकर्ताओं को जोड़ने से पहले समूह को सहेज लें।`)
};

const pt_pt2_team_manager_save_group_before_users = /** @type {(inputs: Team_Manager_Save_Group_Before_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, salve o grupo antes de adicionar usuários.`)
};

/**
* | output |
* | --- |
* | "Please save the group first before adding users." |
*
* @param {Team_Manager_Save_Group_Before_UsersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_save_group_before_users = /** @type {((inputs?: Team_Manager_Save_Group_Before_UsersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Save_Group_Before_UsersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_save_group_before_users(inputs)
	if (locale === "de") return de_team_manager_save_group_before_users(inputs)
	if (locale === "it") return it_team_manager_save_group_before_users(inputs)
	if (locale === "ru") return ru_team_manager_save_group_before_users(inputs)
	if (locale === "es") return es_team_manager_save_group_before_users(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_save_group_before_users(inputs)
	if (locale === "ja") return ja_team_manager_save_group_before_users(inputs)
	if (locale === "hi") return hi_team_manager_save_group_before_users(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_save_group_before_users(inputs)
	return en_team_manager_save_group_before_users(inputs)
});